import { Box, Typography } from "@mui/material";

const BlockGame = () => {
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box sx={{ p: 1 }}>
        <Typography
          variant="body2"
          sx={{ color: "#ff4d4f", fontSize: 12, fontWeight: 600 }}
        >
          Not Available in Your Region
        </Typography>
      </Box>
    </Box>
  );
};
export default BlockGame;
